// extracted by mini-css-extract-plugin
export default {"root":"LoginBlock-root_GZfjy","iconContainer":"LoginBlock-iconContainer_fAfkg"};